import React from "react";
import styled, { keyframes } from "styled-components";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import SubVisual from "../Public/SubVisual";
import { DHKS_INFO } from "../../../Models/CompanyInfoData";

const reveal = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Recruit = () => {
  const handleDownload = () => {
    window.location.href = `${process.env.REACT_APP_BACK_API_URL}/API/HomePage/Notice/download/applicationForm`;
  };

  return (
    <>
      <Header />
      <SubVisual title="채용공고" subTitle="인재채용" />

      <PageContainer>
        <InnerWrapper>
          {/* Section 1: 회사 소개 및 인재상 */}
          <CompanyIntro>
            <div className="label-box"></div>
            <h2 className="main-title">
              세계 반도체 시장의 미래를
              <br />
              함께 이끌어나갈 인재를 찾습니다.
            </h2>
            <p className="desc">
              {DHKS_INFO.companyKRName}은
              <br />
              Grinding 및 Sawing 장비 세계 시장 점유율 70% 이상을 확보하고 있는
              <br />
              日 DISCO社와의 합작법인으로서, 다양한 국내외 주요 글로벌 반도체
              업체들과 협업하며
              <br />
              DISCO社 장비를 독점 공급 및 관리하는 Total Solution
              Provider입니다.
              <br />
              당사는 세계 반도체 시장의 미래를 함께 이끌어나갈 인재를
              모집합니다.
            </p>
          </CompanyIntro>

          <SectionTitle>상시 모집</SectionTitle>
          <TableContainer>
            <RecruitTable>
              <thead>
                <tr>
                  <th>모집부문</th>
                  <th>담당 직무</th>
                  <th>지원자격 및 우대사항</th>
                  <th>신입/경력</th>
                  <th>근무지</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="cate">
                    반도체 장비 <br />
                    엔지니어
                  </td>
                  <td className="job">
                    반도체 장비 Set-up,
                    <br className="desktop-br" />
                    Total Solution 제공
                  </td>
                  <td className="spec">
                    <div>
                      <div className="spec-title">
                        {"["}지원자격{"]"}
                      </div>
                      <ul className="spec-list">
                        <li>• 학력 및 전공 무관</li>
                      </ul>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      <div className="spec-title">
                        {"["}우대사항{"]"}
                      </div>
                      <ul className="spec-list">
                        <li>• 공학 계열 전공자</li>
                      </ul>
                    </div>
                  </td>
                  <td className="loc">경력무관</td>
                  <td className="loc">동탄 / 아산</td>
                </tr>
                <tr>
                  <td className="cate">
                    반도체 장비 <br />
                    영업
                  </td>
                  <td className="job">
                    국내 주요 반도체 고객사에 대한 <br className="desktop-br" />
                    장비 판매, 기술 제안, 프로젝트 관리 업무
                  </td>
                  <td className="spec">
                    <div>
                      <div className="spec-title">
                        {"["}지원자격{"]"}
                      </div>
                      <ul className="spec-list">
                        <li>• 비즈니스 일본어 가능자</li>
                        <li>• 학력 및 전공 무관</li>
                      </ul>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      <div className="spec-title">
                        {"["}우대사항{"]"}
                      </div>
                      <ul className="spec-list">
                        <li>• 일본 거주 경험자</li>
                      </ul>
                    </div>
                  </td>
                  <td className="loc">경력무관</td>
                  <td className="loc">판교</td>
                </tr>
              </tbody>
            </RecruitTable>
          </TableContainer>

          {/* Section 3: 근무 조건 및 복리후생 */}
          <TwoColSection>
            <div className="content-box">
              <SectionTitle>근무 조건</SectionTitle>
              <ConditionList>
                <li>
                  <strong>고용 형태</strong>
                  <div className="desc-text">정규직</div>
                </li>
                <li>
                  <strong>근무 일시</strong>
                  <div className="desc-text">주 5일 (월~금) 09:00 ~ 18:00</div>
                </li>
                <li>
                  <strong>급여 조건</strong>
                  <div className="desc-text">
                    회사 내규에 따름 (면접 후 결정)
                  </div>
                </li>
                <li>
                  <strong>복리 후생</strong>
                  <div className="desc-text">
                    차량지원금 및 각종 인센티브 지급
                    <br />
                    통신비 지원
                    <br />
                    종합검진 지원
                    <br />
                    직무 유관 교육비 지원 등
                  </div>
                </li>
              </ConditionList>
            </div>

            <div className="content-box">
              <SectionTitle>채용 절차</SectionTitle>
              <ProcessStep>
                <div className="step">
                  <span className="step-num">01</span>
                  <div className="step-txt">
                    <strong>서류 전형</strong>
                    <p>이력서 및 자기소개서 제출</p>
                  </div>
                </div>
                <div className="step">
                  <span className="step-num">02</span>
                  <div className="step-txt">
                    <strong>면접 전형</strong>
                    <p>실무진 및 임원 면접</p>
                  </div>
                </div>
                <div className="step">
                  <span className="step-num">03</span>
                  <div className="step-txt">
                    <strong>최종 합격</strong>
                    <p>합격 통보 및 처우 협의</p>
                  </div>
                </div>
              </ProcessStep>

              <ContactInquiry>
                <div className="inquiry-title">채용 문의 및 서류 접수</div>
                <div className="info-row">
                  <div className="info-item">
                    <span className="label">E-MAIL</span>
                    <span className="val">recruit@dhk.co.kr</span>
                  </div>
                  <div className="info-item">
                    <span className="label">TEL</span>
                    <span className="val">031-639-9031 (인사담당자)</span>
                  </div>
                </div>
                <p className="notic-text">
                  * 이메일로 이력서 제출 시 파일명은{" "}
                  <strong>[지원부문_성함]</strong> 형식으로 제출해 주시기
                  바랍니다.
                </p>
                <ApplyBtn
                  style={{
                    marginRight: "10px",
                    backgroundColor: "gray",
                    color: "#fff",
                  }}
                  onClick={handleDownload}
                >
                  지원양식 다운로드
                </ApplyBtn>
              </ContactInquiry>
            </div>
          </TwoColSection>
        </InnerWrapper>
      </PageContainer>

      <Footer />
    </>
  );
};

export default Recruit;

// --- 스타일 컴포넌트 ---

const PageContainer = styled.div`
  width: 100%;
  background-color: #fff;
  padding-bottom: 150px;

  @media (max-width: 768px) {
    padding-bottom: 80px; /* 모바일 하단 여백 축소 */
  }
`;

const InnerWrapper = styled.div`
  width: 90%;
  max-width: 1300px;
  margin: 0 auto;
`;

const CompanyIntro = styled.div`
  padding: 120px 0 80px 0;
  animation: ${reveal} 1s ease-out forwards;

  .label-box {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    .dot {
      width: 6px;
      height: 6px;
      background: #00d2ff;
      border-radius: 50%;
    }
    .label {
      font-size: 0.9rem;
      font-weight: 700;
      color: #00d2ff;
      letter-spacing: 3px;
    }
  }

  .main-title {
    font-size: 3.2rem;
    font-weight: 800;
    line-height: 1.3;
    color: #1a1a1a;
    margin-bottom: 30px;
  }

  .desc {
    font-size: 1.15rem;
    color: #666;
    line-height: 1.8;
    word-break: keep-all;
  }

  @media (max-width: 768px) {
    padding: 60px 0 40px 0; /* 모바일 상하 여백 축소 */

    .main-title {
      font-size: 2.2rem; /* 폰트 사이즈 조정 */
      br {
        display: none;
      } /* 자연스러운 줄바꿈 유도 */
    }

    .desc {
      font-size: 1rem;
      br {
        display: none;
      } /* 모바일에서 어색한 중간 줄바꿈 제거 */
    }
  }
`;

const SectionTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 40px;
  padding-left: 15px;
  border-left: 4px solid #00d2ff;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 25px;
    padding-left: 10px;
  }
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto; /* 내용이 넘칠 경우 가로 스크롤 생성 */
  margin-bottom: 100px;
  animation: ${reveal} 1s ease-out 0.3s forwards;
  opacity: 0;

  /* 스크롤바 디자인 (선택사항) */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    margin-bottom: 60px;
  }
`;

const RecruitTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 800px; /* 모바일에서 표가 과도하게 찌그러지지 않도록 최소 너비 유지 */

  ul.spec-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin-bottom: 4px;
    }
  }

  .spec-title {
    font-weight: 700;
    margin-bottom: 8px;
  }

  th {
    background-color: #f8f9fa;
    color: #1a1a1a;
    font-weight: 700;
    padding: 20px;
    border-top: 2px solid #1a1a1a;
    border-bottom: 1px solid #eee;
    text-align: left;
    font-size: 1rem;
    white-space: nowrap; /* 제목칸 줄바꿈 방지 */
  }

  td {
    padding: 30px 20px;
    border-bottom: 1px solid #eee;
    vertical-align: top;
    font-size: 1rem;
    color: #444;
    line-height: 1.6;

    &.cate {
      font-weight: 800;
      color: black;
      white-space: nowrap;
    }
    &.job {
      font-weight: 700;
      color: #1a1a1a;
    }
    &.loc {
      font-weight: 600;
      white-space: nowrap;
    }
  }

  tbody tr:hover {
    background-color: rgba(0, 210, 255, 0.02);
  }

  @media (max-width: 768px) {
    min-width: 650px; /* 모바일에서는 최소 너비를 살짝 줄여 스크롤 부담 완화 */
    th {
      padding: 15px 10px;
      font-size: 0.9rem;
    }
    td {
      padding: 20px 10px;
      font-size: 0.95rem;
    }
    .desktop-br {
      display: none; /* 직무 설명 등 모바일에서 불필요한 줄바꿈 제거 */
    }
  }
`;

const TwoColSection = styled.div`
  display: flex;
  gap: 80px;
  animation: ${reveal} 1s ease-out 0.6s forwards;
  opacity: 0;

  .content-box {
    flex: 1;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 60px;
  }
  @media (max-width: 768px) {
    gap: 50px;
  }
`;

const ConditionList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    display: flex;
    align-items: flex-start;
    font-size: 1.1rem;
    color: #555;
    margin-bottom: 20px;
    line-height: 1.8;

    strong {
      color: #1a1a1a;
      min-width: 100px;
      flex-shrink: 0;
      position: relative;

      &::after {
        content: ":";
        position: absolute;
        right: 15px;
      }
    }

    .desc-text {
      flex: 1;
      word-break: keep-all;
    }
  }

  @media (max-width: 768px) {
    li {
      flex-direction: column; /* 모바일에서는 항목명과 내용 위아래 배치 */
      gap: 5px;
      margin-bottom: 25px;

      strong {
        min-width: auto;
        font-size: 1rem;
        &::after {
          display: none; /* 위아래 배치 시 콜론(:) 숨김 처리 */
        }
      }

      .desc-text {
        font-size: 0.95rem;
      }
    }
  }
`;

const ProcessStep = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 40px;

  .step {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    .step-num {
      font-size: 1.2rem;
      font-weight: 900;
      color: #00d2ff;
    }
    .step-txt {
      strong {
        font-size: 1.1rem;
        color: #1a1a1a;
        display: block;
        margin-bottom: 5px;
      }
      p {
        font-size: 0.95rem;
        color: #777;
        margin: 0;
      }
    }
  }

  @media (max-width: 768px) {
    gap: 20px;
    .step .step-txt strong {
      font-size: 1.05rem;
    }
    .step .step-txt p {
      font-size: 0.9rem;
    }
  }
`;

const ContactInquiry = styled.div`
  margin-top: 40px;
  padding: 40px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-top: 3px solid #1a1a1a;

  .inquiry-title {
    font-size: 1.2rem;
    font-weight: 800;
    color: #1a1a1a;
    margin-bottom: 25px;
  }

  .info-row {
    display: flex;
    gap: 40px;
    margin-bottom: 25px;

    .info-item {
      .label {
        display: block;
        font-size: 0.75rem;
        font-weight: 800;
        color: #00d2ff;
        margin-bottom: 5px;
        letter-spacing: 1px;
      }
      .val {
        font-size: 1.05rem;
        font-weight: 600;
        color: #333;
      }
    }
  }

  .notic-text {
    font-size: 0.9rem;
    color: #888;
    margin-bottom: 30px;
    line-height: 1.5;
    word-break: keep-all;
    strong {
      color: #00d2ff;
    }
  }

  @media (max-width: 768px) {
    padding: 25px; /* 내부 패딩 축소 */

    .inquiry-title {
      font-size: 1.1rem;
    }

    .info-row {
      flex-direction: column; /* 연락처 정보 상하 배치 */
      gap: 15px;
    }
  }
`;

const ApplyBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 18px 40px;
  background-color: #1a1a1a;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  border-radius: 4px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    background-color: #00d2ff;
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 210, 255, 0.2);
  }

  &:hover {
    cursor: pointer;
    background-color: #00d2ff !important;
    transform: translateY(-5px);
  }

  @media (max-width: 1200px) {
    margin-top: 20px;
  }
  @media (max-width: 768px) {
    width: 100%; /* 모바일에서는 버튼을 꽉 차게 만들어 터치하기 쉽게 변경 */
    padding: 15px 20px;
    margin-top: 20px;
    &:hover {
      transform: none; /* 모바일 터치 환경에서 호버 모션 제거 */
    }
  }
`;
